import React, { useEffect, useMemo } from 'react'
import { View, StyleSheet } from 'react-native'
import { ForwardButton, NavButton } from '../../../../components/Headers/UIButtons'
import Colors from '../../../../constants/Colors'
import { useAppDispatch, useAppSelector } from '../../../../state/hooks'
import { setCheckoutState } from '../../../../state/Slices/checkoutSlice'
import { useRetrieveDataContext } from '../../../../context/RetrieveDataContext'

export function ButtonContainer({ handleBack, toggleModal, isGiftCardOrder }) {
	const {
		isCardValid,
		selectedCard,
		useNewPaymentMethod,
		loading,
		digitalWalletType,
		isDigitalWalletEnabled,
		prices,
	} = useAppSelector(state => state.checkout)
	const { triggerValidateCartItems } = useRetrieveDataContext()
	const dispatch = useAppDispatch()
	const typePOS = useAppSelector(state => state.checkout.typePOS)
	const isPaymentDisabled = global.pos && typePOS === ''
	// Re-render when variables change
	const isButtonEnabled = useMemo(() => {
		return (
			prices.total === 0 ||
			(isCardValid && useNewPaymentMethod) ||
			(!useNewPaymentMethod && !loading && selectedCard) ||
			(selectedCard === digitalWalletType && isDigitalWalletEnabled) ||
			global.kiosk
		)
	}, [isCardValid, useNewPaymentMethod, loading, selectedCard, toggleModal])
	return (
		<View style={styles.row}>
			<View style={styles.flexButton}>
				<ForwardButton onPress={handleBack} color={'white'} title={'BACK'} />
			</View>
			<View style={[styles.flexButton, { marginLeft: 20, maxWidth: '40%' }]}>
				<ForwardButton
					onPress={
						isPaymentDisabled
							? null
							: isButtonEnabled
								? async event => {
										const isValid = await triggerValidateCartItems()

										if (!isValid && !isGiftCardOrder) return
										toggleModal(event)
									}
								: () => {
										dispatch(
											setCheckoutState({ cardErrorMessage: 'Your card details are incomplete.' })
										)
									}
					}
					color={isButtonEnabled && !isPaymentDisabled ? global.orgColor : Colors.greyscale[6]}
					opacity={isButtonEnabled ? 1 : 0.5} // Adjust opacity for disabled state if needed
					title={prices.total === 0 ? 'CONFIRM' : 'PAY NOW'}
					showChevron={false}
				/>
			</View>
		</View>
	)
}

const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
		flex: 1,
		justifyContent: 'space-between',
	},
	flexButton: {
		flex: 1,
		maxWidth: '33%',
	},
})
